var $c2f7f93bc3d97c0b$exports = {};
$c2f7f93bc3d97c0b$exports = {
    "pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`
};


export {$c2f7f93bc3d97c0b$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
